import { mapState } from 'vuex'
import StarterData from '../assets/stamen.json'
const SSta = require('simple-statistics');
export default {
  data () {
    return {
      resultmax: 20,
      ReadRecord: {
        'G': '試合',
        'PA': '打席',
        'AB': '打数',
        'R': '得点',
        'H': '安打',
        'SING': '単打',
        'SEC': '二塁',
        'THI': '三塁',
        'HR': '本塁',
        'RBI': '打点',
        'BB': '四球',
        'SO': '三振',
        'SB': '盗塁',
        'CS': '盗死',
        'SH': '犠打',
        'AVG': '打率',
        'GS': '先発',
        'CG': '完投',
        'ShO': '完封',
        'W': '勝利',
        'L': '敗戦',
        'OBP': '出率',
        'SLG': '長率',
        'IPa': '投球回',
        'IPb': '小数点',
        'ER': '自責',
        'ERA': '防御率',
        'WR': '勝率',
        'SV': 'Ｓ',
        'HLD': 'Ｈ',
        'TBF': '打者',
        'HBP': '死球',
        'DEF': '位置',
        'age': '年齢',
        'hand': '利き腕',
        'heig': '身長',
        'weig': '体重',
        'name': '名前',
        'OUT': '凡打'
      },
    }
  },
  computed: {
    SH_flag () {
      return this.SH_use
    },
    EventsList () {
      let evlist = ['SING', 'SEC', 'THI', 'HR', 'BB', 'HBP', 'SO', 'OUT']
      //if(this.SH_flag)evlist.push('SH')
      return evlist
    },
    PosList () {
      return ['投', '捕', '一', '二', '三', '遊', '外', '指']
    },
    InputHandList () {
      const hand = {
        b: ['右打', '左打', '両打'],
        p: ['右投', '左投', '両投']
      }
      return hand[this.PBcheck]
    },
    Setubi (r) {
      const s = { heig: 'cm', weig: 'kg' }
      if (s[r] === undefined) {
        return ''
      } else {
        return s[r]
      }
    },
    InputRecordList () {
      return ['name', 'AB', 'H', 'SEC', 'THI', 'HR', 'BB', 'HBP', 'SO']
    },
    FilterRecordList () {
      return  ['name', 'PA', 'AB', 'H', 'SEC', 'THI', 'HR', 'RBI', 'BB', 'HBP', 'SO', 'AVG', 'OBP', 'SLG', 'OPS']
    },
    CateList () {
      return ['リーグ', '球団', '選手']
    },
    calcWari () {
      return function (a, b) {
        const bunsi = Number(a)
        const bunbo = Number(b)
        if (isNaN(bunsi) || isNaN(bunbo)) return 0
        if (bunbo === 0 && bunsi === 0) return 0
        if (bunbo === 0 && bunsi > 0) return 99999
        return bunsi / bunbo
      }
    },
    ...mapState([
      'TabActive',
      'suggestionList',
      'users',
      'result_players',
      'Tabselect',
      'targetMatchName',
      'LineUp',
      'OverReplacement',
      'GameRange', 'YearRange',
      'result_sim',
      'SeachFilter',
      'AppTitle',
      'SH_use',
    ]),
    PrintRecordList () {
        return ['AB', 'AVG', 'OBP', 'SLG', 'OPS']
    },
    RecordName () {
      return function (r) {
        return (r in this.ReadRecord ? this.ReadRecord[r] : r)
      }
    },
    printAVG () {
      return function (avg, conm) {
        if (isNaN(avg)) return '.'
        const avgnum = Number(avg)
        var str = String(Math.round(avgnum * Math.pow(10, conm)))
        const zflag = (conm === 3)
        if (avgnum === 0) str = '0'
        while(str.length < 3) str = '0' + str
        function strIns(str, idx, val){
          const to_str = str.slice()
          return to_str.slice(0, idx) + val + to_str.slice(idx);
        };
        if(str.length > 3) {
          return strIns(str, str.length - 3, '.')
        }else{
          return '.' + str
        }
        //if (avgnum < 1.00 && zflag)str = str.slice(1)
        //if (str.indexOf('.') === -1 && str.length <= conm)str += '.'
        //if (conm - zflag - str.length + 2 > 0)str += zero.slice(0, conm - zflag - str.length + 2)
        
      }
    },
    printDEF () {
      return function (def) {
        let posstr = ''
        this.PosList.some(pos => {
          if (def.indexOf(pos) > -1)posstr += pos
        })
        return posstr
      }
    },
    CheckStamem() {
      return function(t, nen) {
        const team = this.teamID(t)
        return (team in StarterData && Number(nen) in StarterData[team]);
      }
    },
    SH_OutList() {
      return ['0 100','0 010','0 110','1 100','1 010','1 110']
    },
  },
  methods: {
    StrRunner (run) {
      let str = ''
      const runten = parseInt(run, 2);
      if(runten == 7)return '満塁'
      if(runten == 0)return '無し'
      if(runten >= 4)str += '1'
      if(runten % 4 == 2||runten % 4 == 3)str += '2'
      if(runten % 2)str += '3'
      return str + '塁'
    },
    Str_OutRun (ro) {
      function Outstr (out) {
        return (out == '0' ? '無' : out == 1 ? '一' : out == 2 ? '二' : '三')
      }
      const out = ro.split(' ')
      return Outstr(out[0]) + '死' + this.StrRunner(out[1])
    },
    ListAction(num, user) {
      if(num == 0){
        this.CpyPlayer(-1, user)
      }else if(num == 1){
        this.CpyPlayer(9, user)
      }else{
        this.TeamInputLineUp(user.team, user.nen)
      }
    },
    ZeroEx (para) {
      if (para === undefined || para === '') return 0
      return Number(para)
    },
    calcRecord (rname, r) {
      switch (rname) {
        case 'AB':
          if(isFinite(r.AB))return r.AB;else
          return r.OUT + this.calcRecord('H', r) + r.SO
        case 'H':
          if(isFinite(r.H))return r.H;else
          return r.SING + r.SEC + r.THI + r.HR
        case 'ERA':
          return this.calcERA(r)
        case 'FIP':
          return this.calcFIP(r, false)
        case 'PA':
          return this.calcRecord('AB', r) + this.calcRecord('BB', r) + this.calcRecord('HBP', r)  + this.calcRecord('SH', r) 
        case 'Kpa':
          return this.calcWari(r.SO, this.calcRecord('PA', r))
        case 'HRpa':
          return this.calcWari(r.HR, this.calcRecord('PA', r))
        case 'Bpa':
          return this.calcWari(r.BB, this.calcRecord('PA', r))
        case 'HBPpa':
          return this.calcWari(r.HBP, this.calcRecord('PA', r))
        case 'SBSC':
          return r.SB + r.SC
        case 'WR':
          return this.calcWari(r.W, r.W + r.L)
        case 'SBGO':
          return this.calcWari(r.SB, r.CS)
        case 'OBP':
          return this.calcWari(this.calcRecord('H', r) + r.BB + r.HBP, this.calcRecord('AB', r) + r.BB + r.HBP)
        case 'ISOP':
          return this.calcRecord('SLG', r) - this.calcRecord('AVG', r)
        case 'SLG':
          return this.calcWari(this.calcRecord('H', r) + r.SEC + r.THI * 2 + r.HR * 3, this.calcRecord('AB', r))
        case 'AVG':
          {
            return this.calcWari(this.calcRecord('H', r), this.calcRecord('AB', r))
          }
        case 'OPS':
          return this.calcRecord('SLG', r) + this.calcRecord('OBP', r)
        case 'SECpa':
          return this.calcWari(r.SEC + r.THI, this.calcRecord('H', r))
        case 'GSpa':
          return this.calcWari(r.GS, r.G)
        case 'IP':
          return r.IPa + this.calcWari(r.IPb, 3)
        case 'heig':
          return (r.heig > 0 ? r.heig : 175)
        case 'weig':
          return (r.weig > 0 ? r.weig : 75)
        case 'hand':
          const param = (r.hand.indexOf('左打') > -1) * 1 + (r.hand.indexOf('両打') > -1) * 2 +
          (r.hand.indexOf('左投') > -1) * 3 + (r.hand.indexOf('両投') > -1) * 6
          return param
        default:
          return r[rname] ? r[rname] : 0
      }
    },
    RandNameSet () {
      const rec = (this.PBcheck === 'p' ? 'IPa' : 'H')
      const hundred = this.users.filter(p =>
        (Number(p.nen) > 1960) && (p[rec] >= (50))
      )
      var player = hundred[parseInt(Math.random() * (hundred.length - 1))]
      this.setID(player.id, player.nen)
      return 1
    },
    nameSlice (str) {
      return {name: str, year: '0'}
      const target = str.indexOf('/')
      if (target < 0) return {name: str, year: '0'}
      return {name: str.substring(0, target), year: str.substring(target + 1)}
    },
    seachName (inputName, team, nen, category) {
      function Spacecut (str) {
        return str.replace(' ', '').replace('　', '').replace('.', '')
      }
      console.log(inputName+ team+ nen+ category)
      const seachteam = (team instanceof Array ? team : team == "" || team == null ? [] : [team])
      const seachnen = (nen instanceof Array ? nen : nen == "" || nen == null ? [] : [nen])
      const seachcate = (category instanceof Array ? category : category == "" || category == null ? [] : [category])
      let target = {name: inputName, year: 0}
      target = this.nameSlice(inputName)
      target.name = Spacecut(target.name)
      let setplayers = []
      console.log(this.SeachFilter)
      function FilterCheck (p, filter) {
        let not = false
        Object.keys(filter).some(fil =>{
          not = ((filter[fil][0] == '' || Number(filter[fil][0]) <= p[fil]) && 
          (filter[fil][1] == '' || Number(filter[fil][1]) >= p[fil])
          )
          return !not
        })
        return not
      }
      this.users.some((p) => {
        if ((target.name == "" || Spacecut(p.name).indexOf(target.name) > -1)
        && (seachcate.length == 0 || seachcate.indexOf('ALL') > -1 || seachcate == p.category)
        && (seachteam.length == 0 || seachteam.indexOf('ALL') > -1 || seachteam.indexOf(this.teamID(p.team)) > -1)
        && (seachnen.length == 0 || seachnen == 'ALL' || seachnen == p.nen)
        && FilterCheck(p, this.SeachFilter)
        )setplayers.push(p)
        if(setplayers.length >= 2000)return true
      })
      this.$store.dispatch('setValue', {vals: setplayers, keyname: 'result_players'})
    },
    setRecord (p) {
      let record = this.EmptyPlayer(0)
      Object.keys(p).some((rec) => {
        record[rec] = p[rec]
      })
      if(p['SF'])record['AB'] += p['SF']
      record['name'] = p['name']
      return record
    },
    posSet (def) {
      let poscount = {
        '投': 0,
        '捕': 0,
        '一': 0,
        '二': 0,
        '三': 0,
        '遊': 0,
        '外': 0,
        '指': 0
      }
      if (def === '' || def === 0) return poscount
      let dlist = def.replace(/(\D)(\d+)/g, '$1$2,').split(',').slice(0, -1)
      dlist.some(pos => {
        poscount[pos[0]] = Number(pos.replace(/[^0-9]/g, ''))
      })
      return poscount
    },
    setPosition (player) {
      var selects = []
      if (this.PosNumFlag) {
        this.$store.dispatch('setValue', {vals: this.posSet(player.DEF), keyname: 'inputedPoss'})
      } else {
        this.PosList.some((p, index) => {
          selects[index] = (player.DEF.indexOf(p) > -1)
        })
        this.$store.dispatch('setValue', {vals: selects, keyname: 'selectedPoss'})
      }
    },
    parseBoolean(str) {
      // 文字列を判定
      if(typeof (str) == "string" || str instanceof String)return (str == 'true' || str == '1') ? true : false;
      return Boolean(str)
    },
    teamID (n, numflag = 0) {
      const teamset = {// 福岡ソフトバンク→ソフトバンク 北海道日本ハム→日本ハム
        '巨人': ['読売ジャイアンツ', '東京巨人軍'],
        "横浜DeNA": ['DeNAベイスターズ', '横浜ベイスターズ', "大洋ホエールズ", "洋松ロビンス"],
        '阪神': ['阪神タイガース', '大阪タイガース', "タイガース"],
        "中日": ['名古屋ドラゴンズ', '中部日本', '中日ドラゴンズ', '産業'],
        "広島東洋": ["広島カープ"],
        "東京ヤクルト": ["ヤクルトアトムズ", "ヤクルトスワローズ", "サンケイスワローズ", "国鉄スワローズ", "アトムズ", "サンケイアトムズ"],
        "オリックス": ["阪急", "阪急ブレーブス", 'オリックスバファローズ', 'オリックスブルーウェーブ', 'オリックスブレーブス'],
        "ソフトバンク": ["ソフトバンクホークス", "ダイエーホークス", "南海ホークス", "南海", "近畿日本", "グレートリング", "福岡ソフトバンク"],
        "日本ハム": ['セネタース', "急映フライヤーズ", "東映フライヤーズ", "東急フライヤーズ", "日拓フライヤーズ", "日本ハムファイターズ", "北海道日本ハム"],
        "千葉ロッテ": ["ロッテオリオンズ", "大毎オリオンズ", "東京オリオンズ", "毎日オリオンズ", "ロッテマリーンズ"],
        "埼玉西武": ["クラウンライオンズ", "西鉄ライオンズ", "西武ライオンズ", "太平洋ライオンズ", "西鉄クリッパース"],
        "東北楽天": ["楽天イーグルス", "東北楽天"],
        "近鉄": ["近鉄パールス", "近鉄バファロー", "近鉄バファローズ", "近鉄"],
        "松竹ロビンス": ["大東京", "ライオン", "朝日", "パシフィック", '太陽ロビンス', "大陽ロビンス", "松竹ロビンス"],
        "イーグルス": ["イーグルス", "黒鷲", "大和"],
        "東京セネタース": ["東京セネタース", "翼", "大洋", "西鉄"],
        "金鯱": ["金鯱", "名古屋"],
        "トンボユニオンズ": ["高橋ユニオンズ", "トンボユニオンズ"],
        "西日本パイレーツ": ["西日本パイレーツ"],
        "大映ユニオンズ": ["ゴールドスター", "金星スターズ", "大映スターズ", "大映ユニオンズ"],
        "1リーグ": ["1リ", "1リーグ"],
        "セ・リーグ": ["セ"],
        "パ・リーグ": ["パ"],
      }
      const teamset_list = Object.keys(teamset)
      for(let ts = 0;ts < teamset_list.length; ts=ts+1){
        if(n == teamset_list[ts])return (numflag ? ts:teamset_list[ts]);
        const teams_list = Object.values(teamset[teamset_list[ts]])
        for(let t = 0;t < teams_list.length; t=t+1){
          if(n == teams_list[t])return (numflag ? ts :teamset_list[ts]);
        }
      }
      return null
    },
    TeamInputLineUp(team, nen) {
      let toteam = team, tonen = String(nen)
      if(team instanceof Array)toteam = team[0]
      if(nen instanceof Array)tonen = String(nen[0])
      const ti = this.teamID
      let stam = []
      const seacht = ti(toteam)
      //if(false){
        console.log("aaa");
      if(this.CheckStamem(seacht, tonen)) {
        Object.values(StarterData[seacht][tonen]).some((id, index) => {
          const player = this.users.find(p => {
            return (id == Number(p.id) && String(p.nen) == tonen && ti(p["team"]) == seacht)
          })
          stam.push(player)
        })
        console.log(stam);
        this.$store.commit('updateValue', {vals: StarterData[seacht][tonen].GS, keyname: 'GameRange'});
      }else{
        const filters = this.users.filter(p =>
          (String(p.nen) == tonen || tonen == 'ALL' || tonen == undefined) && (ti(p["team"]) == seacht || team == 'ALL' || team == undefined)
        )
        stam = filters.sort(function(a,b){
          if(a.AB < b.AB) return 1;if(a.AB > b.AB) return -1;return 0;
        });
      }
      const dhflag = Number(this.useDH(seacht, tonen))
      if(stam.length >= 8 + dhflag){
        console.log("DH:" + dhflag)
        stam = stam.splice(0, 8 + dhflag)
        if(dhflag == 0 && this.LineUp[8].lock == false)stam.push(this.PitcherPlayer(seacht, tonen, this.LineUp[8]))
        console.log(toteam + "t:n" + tonen)
        stam.some((s, jun) => {
          this.CpyPlayer(jun, s)
        })
      }else{
        return false
      }
      return true
    },
    CpyPlayer (jun, user) {
      let ls = this.LineUp.slice()
      if(jun == -1) {
        if(ls.length < 20){
          ls.push(this.setRecord(user))
          ls[ls.length - 1].jun = ls.length - 1
        }
      }else
      for(let j = 0; j<9; j=j+1){
        if(j >= (jun >= 9 ? 0 : jun) && j < (jun >= 9 ? 9 : jun + 1)){
          if(ls[j].lock == false)ls[j] = this.setRecord(user)
        }
        ls[j].jun = j
      }
      this.$store.commit('updateValue', {vals: ls, keyname: 'LineUp'})
    },
    useDH (t, nen) {
      const teamid = this.teamID(t)
      return (
        (teamid == 'オリックス' ||
        teamid == 'ソフトバンク' ||
        teamid == '日本ハム' ||
        teamid == '千葉ロッテ' ||
        teamid == '埼玉西武' ||
        teamid == '東北楽天' ||
        teamid == '近鉄'
        ) && Number(nen) >= 1975
      )
    },
    Leag(t, nen){
      const n = nen.replace(/[^0-9]/g, '');
      if(Number(n) <1950 || t=='1リーグ')return '1リーグ';
      const id = this.teamID(t)
      if(id < 6 || t == 13 || t == 18　|| 'セ・リーグ')return 'セ・リーグ';
      return 'パ・リーグ';
    },
    EmptyPlayer(jun, zero = false) {
      let obj = {}
      this.InputRecordList.some(r =>{
        obj[r] = (r != 'name' ? 0 : '')
      })
      obj['jun'] = jun
      obj['SH_play'] = false
      obj['lock'] = false
      obj['SH_plan'] = 40
      obj['SH_rate'] = 81
      obj['SH_out'] = {}
      this.SH_OutList.some(sho => {
        obj['SH_out'][sho] = false
      })
      obj['SH_out']['0 100'] = true
      return obj
    },
    PitcherPlayer(t, nen, obj) {
      if(this.CheckStamem(t, nen)){
        const leag = this.Leag(t, nen).slice(0, 1) + '/投手';
        const tp = this.users.find(p => {
          return (leag == p.name && String(p.nen) == nen)
        })
        console.log(this.users)
        Object.keys(tp).some(rec => {
          obj[rec] = tp[rec]
        })
        obj['SH_play'] = true
        obj['SH_plan'] = 100
        obj['SH_rate'] = 58
        obj['SH_out'] = {
          '0 100': true,
          '0 010': false,
          '0 110': true,
          '1 100': true,
          '1 010': false,
          '1 110': true,
        }
        obj.name = "投手"
      }
      //obj.lock = true
      return obj
    },
    ObjectListSort (obj, syoko, param, syoko2 = -1, param2 = "") {
      return obj.sort(function(a,b) {
        if(a[param]>b[param]) return (syoko ? -1 : 1);
        if(a[param]<b[param]) return (syoko ? 1 : -1);
        if(syoko2 > -1) {
          if(a[param2]>b[param2]) return (syoko2 ? -1 : 1);
          if(a[param2]<b[param2]) return (syoko2 ? 1 : -1);
        }
        return 0;
      });
    },
    uuid(e) {
      if (e.uid) return e.uid;

      const key = Math.random()
        .toString(16)
        .slice(2);

      this.$set(e, "uid", key);
      
      return e.uid;
    },
    print(a) {
      console.log(a)
      return '[0]'
    },
    hankaku2Zenkaku(str) {
      if(typeof (str) != "string"){
          console.log(str)
      }
      let newstr = str.replace(/[Ａ-Ｚａ-ｚ０-９．]/g, function(s) {
          return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
      newstr = newstr.replace(/　/g, " ").replace(/\n/g,"");//replace("?", "")
      return newstr
    },
    PrintScore(scores) {
      const allscores = scores.reduce((pre,current) => {pre.push(...current);return pre},[]);
      const wari = this.calcWari
      let list = []
      
      //const labels = ['name','試合', '年']
      const labels = ['試合', '年']
      let y_scores = []
      scores.some(ys => {
        y_scores.push(ys.reduce(function(a, x){return a + x;}))
      })
      const typelist = ["name", "平均点", '最頻値', '中央値', '標準偏差', '95%CI']
      labels.some(ptype =>{
        const sumplemax = (ptype == '年' ? y_scores.length : allscores.length)
        function CalcScore(label, scores, sumplemax) {
          if(scores.length == 0)return 0
          switch(label) {
            case '平均点':
            return wari(allscores.reduce(function(a, x){return a + x;}), sumplemax)
            case '最頻値':
              return SSta.mode(scores);
            case '中央値':
              return SSta.median(scores);
            case '標準偏差'://不偏分散
            let sumhen = 0, avs = CalcScore('平均点', scores, sumplemax);
            for(const s of scores){
              sumhen += Math.pow(s - avs, 2)
            }
            return Math.sqrt(1 / (sumplemax - 1) * sumhen);
            //return Math.sqrt(SSta.variance(scores));
            case '95%CI':{
              console.log(scores)
              console.log(sumplemax)
              console.log("CLI!")
              //const cli = CalcScore('標準偏差', scores, sumplemax) / Math.sqrt(sumplemax, sumplemax)*1.96
              //const avs = CalcScore('平均点', scores, sumplemax)
              //const avs = CalcScore('中央値', scores, sumplemax);

              //if(cli == 0) return '-';
              
              //const fpoint = (avs + cli) > 100 ? 1 : 2
              //return (avs + cli).toFixed(fpoint) + '>μ>' + (avs - cli).toFixed(fpoint)
              return 0;
            }
              
          }
        }
        let param = {}
        /*labels.some(ptype =>{
          const sumplemax = (ptype == '年' ? y_scores.length : allscores.length)*/
        typelist.some(function (l) {
          if(ptype === "name") {
            param[l] = l//入れ替えならここは　param[l]-param[ptype]にする
          }else if(l == "name"){
            param[l] = ptype
          }else {
            param[l] = CalcScore(l, ptype == '年' ? y_scores : allscores, sumplemax)
            if(l != "95%CI" && l != '最頻値')param[l] = param[l].toFixed((param[l] > 100 || l == '中央値') ? 1 : 2)
          }
        })
        list.push(param)
        console.log(list)
      });
      
      return list
    },
    ChartDataset(allscores, type) {
        let data = {
        datasets: [
          {
            type: 'bar',
            label: '合計',
            data: [],
            borderWidth: 1,
            yAxisID: "y-axis-1",
          },
          {
            type: 'line',
            label: "累積",
            fill: false,
            lineTension: 0,
            backgroundColor: "rgba(179,181,198,0.8)",
            
            borderColor: "rgba(179,181,198,1)",//枠線の色
            pointBorderColor: "rgba(179,181,198,1)",//結合点の枠線の色
            pointBackgroundColor: "#fff",//結合点の背景色
            pointRadius: 5,//結合点のサイズ
            pointHoverRadius: 8,//結合点のサイズ（ホバーしたとき）
            pointHoverBackgroundColor: "rgba(179,181,198,1)",//結合点の背景色（ホバーしたとき）
            pointHoverBorderColor: "rgba(220,220,220,1)",//結合点の枠線の色（ホバーしたとき）
            pointHitRadius: 12,//結合点より外でマウスホバーを認識する範囲（ピクセル単位）
            //グラフのデータ
            data: [],
            yAxisID: "y-axis-2",
          },
        ]
      }
      let scores = []
      if(type == 'all') {
        scores = allscores.reduce((pre,current) => {pre.push(...current);return pre},[]);

        data.datasets[0].backgroundColor = 'rgba(54, 162, 235, 0.55)'
        data.datasets[0].borderColor = 'rgba(54, 162, 235, 1)'
      }
      if(type == 'nen'){
        allscores.some(ys => { scores.push(ys.reduce(function(a, x){return a + x;}))})

        data.datasets[0].backgroundColor = 'rgba(235, 90, 54, 0.55)'
        data.datasets[0].borderColor = 'rgba(235, 90, 54, 1)'
      }
      let sc_count = {}
      const memori = (type == 'nen' ? 10 : 1)
      scores.some(s => {
        const score = Number(s)
        let sname = ''
        sname = parseInt(this.calcWari(score, memori)) * memori
        if(sc_count[sname] == undefined)sc_count[sname] = 0
        sc_count[sname] ++;
      })
      let sc_count_arr = Object.keys(sc_count)
      const min = Number(sc_count_arr[0])
      const max = Number(sc_count_arr[sc_count_arr.length - 1])

      let max_Percent = 0
      for(let sm = min; sm < max; sm += memori) {
        if(sc_count[sm] == undefined)sc_count[sm] = 0
        max_Percent = Math.max(sc_count[sm] / scores.length, max_Percent)
      }
      const minsize = 10, mline = max_Percent / 9
      if(type == 'all' && max - min > minsize) {
        let total_s = {len: 0,}
        for(let i = max; i > minsize; i--){

          if(total_s.len / scores.length <= mline){
            total_s.len += sc_count[i]
            delete sc_count[i];
          }else{
            sc_count[(i + 1) + '以上'] = total_s.len
            break;
          }
        }
      }
      data['labels'] = []
      let sum = 0
      Object.keys(sc_count).some(s =>{
        data['labels'].push(s)
        data['datasets'][0].data.push(sc_count[s])
        sum += sc_count[s]
        data['datasets'][1].data.push(this.calcWari(sum, scores.length))
      })
      return data;
      //labels: ['January', 'February', 'March', 'April', 'May', 'June'],
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/utility.js